import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { RewardTag } from './reward.tag.actions';
import * as RewardTagActions from './reward.tag.actions';

export interface RewardTagState extends EntityState<RewardTag> {
}

export const rewardTagAdapter: EntityAdapter<RewardTag> = createEntityAdapter<RewardTag>({
  selectId: (rewardTag: RewardTag) => rewardTag.identifier
});

const intialRewardTagState: RewardTagState = rewardTagAdapter.getInitialState();

const _rewardTagReducer = createReducer(
  intialRewardTagState,
  on(RewardTagActions.rewardTagLoaded, (state, { rewardTag }) => {
    return rewardTagAdapter.addMany(rewardTag, state);
  })
);

export function rewardTagReducer(state: RewardTagState | undefined, action: any): RewardTagState {
  return _rewardTagReducer(state, action);
}

export const {
  selectAll,
  selectEntities,
  selectIds,
  selectTotal
} = rewardTagAdapter.getSelectors();



